import { useTranslation } from 'react-i18next';
import { chartText } from '@/i18n/chartText';

/**
 * 商品名称输入区：AI 生成进行中时覆盖骨架加载态。
 */
export default function TitleFieldLoadingShell({
  loading = false,
  label = '生成中…',
  children,
}) {
  useTranslation('workbench');
  const shown = label === '生成中…' ? chartText('publishBasic.generating', '生成中…') : label;
  return (
    <div
      className={`tko-title-field-shell${loading ? ' tko-title-field-shell--loading' : ''}`}
    >
      {children}
      {loading ? (
        <div
          className="tko-title-field-shell__overlay"
          aria-busy="true"
          aria-live="polite"
        >
          <span className="tko-title-field-shell__shimmer" aria-hidden />
          <span className="tko-title-field-shell__content">
            <span className="tko-title-field-shell__spinner" aria-hidden />
            <span className="tko-title-field-shell__text">{shown}</span>
          </span>
        </div>
      ) : null}
    </div>
  );
}
